<h1 mat-dialog-title>
    <span>Balises</span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>

<div mat-dialog-content>
    <list-view *ngIf="listeBalises" [liste]="listeBalises"></list-view>
</div>

<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="insererSelection()">
        <span>Ajouter</span>
    </button>
</div>
